import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from "config/googleAuth";
import { CategoriesContextProvider } from "./General/CategoriesContext";
import { AssessmentProvider } from "./AssessmentContext";
import { LoginAuthProvider } from "./Authentication/LoginAuth";

const ContextProvider = ({ children }) => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <LoginAuthProvider>
        <CategoriesContextProvider>
          <AssessmentProvider>{children}</AssessmentProvider>
        </CategoriesContextProvider>
      </LoginAuthProvider>
    </GoogleOAuthProvider>
  );
};

export default ContextProvider;
